import Vue from 'vue'
import Vuex, { install } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { setMutationStates } from '@/api/async-util'

// modules
import account from '@/store/account'
import activation from '@/store/activation'
import article from '@/store/article'
import auth from '@/store/auth'
import cart from '@/store/cart'
import discountCode from '@/store/discountcode'
import download from '@/store/download'
import enums from '@/store/enums'
import license from '@/store/license'
import oem from '@/store/oem'
import order from '@/store/order'
import payment from '@/store/payment'
import product from '@/store/product'
import revision from '@/store/revision'
import roles from '@/store/roles'
import webinar from '@/store/webinar'
import email from '@/store/email'
import autoactivation from '@/store/autoactivation'

Vue.use(Vuex)

const const_ProductID = 'ProductID'
const const_ProductLineID = 'ProductLineID'
const const_Edition = 'Edition'
const const_Version = 'Version'
const const_InstallID = 'InstallID'
const const_ActivationCode = 'ActivationCode'
const const_FirstName = 'FirstName'
const const_LastName = 'LastName'
const const_Company = 'Company'
const const_Address1 = 'Address1'
const const_Address2 = 'Address2'
const const_City = 'City'
const const_ProvState = 'ProvState'
const const_PostalZip = 'ProstalZip'
const const_Email = 'Email'
const const_Phone = 'Phone'
const const_Fax = 'Fax'
const const_ID = 'ID'
const const_DiscountCode = 'DiscountCode'
const const_NewLicense = 'NewLicense'
const const_UpgradeLicense = 'UpgradeLicense'
const const_Renew = 'Renew'
const const_Move = 'Move'
const const_Secondary = 'Secondary'
const const_Prepaid = 'Prepaid'
const const_OEMID = 'OEMID'
const const_Year = 'Year'

const state = {
    darkmode: localStorage.getItem('darkMode') == 'true' ? true : false,
    isSectionTable: false,
    isSectionTableSm: false,
    infoFromSoftware: {
        productId: '',
        productLineId: '',
        edition: '',
        version: '',
        installId: '',
        activationCode: '',
        firstName: '',
        lastName: '',
        company: '',
        address1: '',
        address2: '',
        city: '',
        provState: '',
        postalZip: '',
        email: '',
        phone: '',
        fax: '',
        id: '',
        discountCode: '',
        newLicense: '',
        upgradeLicense: '',
        renew: '',
        move: '',
        secondary: '',
        prepaid: '',
        oemId: '',
        year: '',
    },
}
const getters = {
    isDarkMode: state => state.darkmode,
    isSectionTable: state => state.isSectionTable,
    isSectionTableSm: state => state.isSectionTableSm,
    infoFromSoftware: state => state.infoFromSoftware,
}
const mutations = {
    update_darkmode(state, darkmode) {
        state.darkmode = darkmode
        localStorage.setItem('darkMode', darkmode)
    },
    update_isSectionTable(state, isSectionTable) {
        state.isSectionTable = isSectionTable
    },
    update_isSectionTableSm(state, isSectionTableSm) {
        state.isSectionTableSm = isSectionTableSm
    },
    update_inforFromSoftware(state, queryInfo) {

        state.infoFromSoftware.productId = queryInfo[const_ProductID] ?? state.infoFromSoftware.productLineId
        state.infoFromSoftware.productLineId = queryInfo[const_ProductLineID] ?? state.infoFromSoftware.productLineId
        state.infoFromSoftware.edition = queryInfo[const_Edition] ?? state.infoFromSoftware.edition
        state.infoFromSoftware.version = queryInfo[const_Version] ?? state.infoFromSoftware.version
        state.infoFromSoftware.installId = queryInfo[const_InstallID] ?? state.infoFromSoftware.installId
        state.infoFromSoftware.activationCode = queryInfo[const_ActivationCode] ?? state.infoFromSoftware.activationCode
        state.infoFromSoftware.firstName = queryInfo[const_FirstName] ?? state.infoFromSoftware.firstName
        state.infoFromSoftware.lastName = queryInfo[const_LastName] ?? state.infoFromSoftware.lastName
        state.infoFromSoftware.company = queryInfo[const_Company] ?? state.infoFromSoftware.company
        state.infoFromSoftware.address1 = queryInfo[const_Address1] ?? state.infoFromSoftware.address1
        state.infoFromSoftware.address2 = queryInfo[const_Address2] ?? state.infoFromSoftware.address2
        state.infoFromSoftware.city = queryInfo[const_City] ?? state.infoFromSoftware.city
        state.infoFromSoftware.provState = queryInfo[const_ProvState] ?? state.infoFromSoftware.provState
        state.infoFromSoftware.postalZip = queryInfo[const_PostalZip] ?? state.infoFromSoftware.postalZip
        state.infoFromSoftware.email = queryInfo[const_Email] ?? state.infoFromSoftware.email
        state.infoFromSoftware.phone = queryInfo[const_Phone] ?? state.infoFromSoftware.phone
        state.infoFromSoftware.fax = queryInfo[const_Fax] ?? state.infoFromSoftware.fax
        state.infoFromSoftware.id = queryInfo[const_ID] ?? state.infoFromSoftware.id
        state.infoFromSoftware.discountCode = queryInfo[const_DiscountCode] ?? state.infoFromSoftware.discountCode
        state.infoFromSoftware.newLicense = queryInfo[const_NewLicense] ?? ''
        state.infoFromSoftware.upgradeLicense = queryInfo[const_UpgradeLicense] ?? ''
        state.infoFromSoftware.renew = queryInfo[const_Renew] ?? ''
        state.infoFromSoftware.move = queryInfo[const_Move] ?? ''
        state.infoFromSoftware.secondary = queryInfo[const_Secondary] ?? ''
        state.infoFromSoftware.prepaid = queryInfo[const_Prepaid] ?? ''
        state.infoFromSoftware.oemId = queryInfo[const_OEMID] ?? state.infoFromSoftware.oemId
        state.infoFromSoftware.year = queryInfo[const_Year] ?? state.infoFromSoftware.year
    },
    reset_info_software(state) {
        state.infoFromSoftware = {
            productId: '',
            productLineId: '',
            edition: '',
            version: '',
            installId: '',
            activationCode: '',
            firstName: '',
            lastName: '',
            company: '',
            address1: '',
            address2: '',
            city: '',
            provState: '',
            postalZip: '',
            email: '',
            phone: '',
            fax: '',
            id: '',
            discountCode: '',
            newLicense: '',
            upgradeLicense: '',
            renew: '',
            move: '',
            secondary: '',
            prepaid: '',
            oemId: '',
            year: '',
        }
    }
}

const actions = {}

export const modules = {
    account,
    activation,
    article,
    auth,
    cart,
    discountCode,
    download,
    enums,
    license,
    oem,
    order,
    payment,
    product,
    revision,
    roles,
    webinar,
    email,
    autoactivation,
}

Object.values(modules).forEach(module => {
    setMutationStates(mutations, module.types)
})

const store = new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.localStorage,
    })],
    state, getters, mutations, actions,
    modules: modules
});

// Listen for storage events to immediately synchronize state across tabs
window.addEventListener('storage', (event) => {
    if (event.key === 'vuex') {
        const newState = JSON.parse(event.newValue);
        store.replaceState(Object.assign(store.state, newState));
    }
});

// Ensure state changes are propagated to localStorage
store.subscribe((mutation, state) => {
    localStorage.setItem('vuex', JSON.stringify(state));
});

export default store;
